import { supabase } from '../supabase';

export const usePoints = {
  // جلب عدد النقاط الحالي للمستخدم
  getUserPoints: async (userPhone) => {
    try {
      const { data: orders, error } = await supabase
        .from('orders')
        .select('id')
        .eq('customer_phone', userPhone)
        .eq('status', 'تم التوصيل')
        .eq('points_status', 'unused');

      if (error) throw error;

      return {
        status: 'success',
        points: orders ? orders.length : 0,
        canRedeemFreeOrder: orders && orders.length >= 10
      };
    } catch (error) {
      console.error('Error getting user points:', error);
      return {
        status: 'error',
        message: error.message || 'حدث خطأ أثناء جلب النقاط',
        points: 0,
        canRedeemFreeOrder: false
      };
    }
  },
  // التحقق من وجود نقاط كافية للطلب المجاني
  checkEligibleForFreeOrder: async (userPhone) => {
    try {
      const { data: orders, error } = await supabase
        .from('orders')
        .select('*')
        .eq('customer_phone', userPhone)
        .eq('status', 'تم التوصيل')
        .eq('points_status', 'unused');

      if (error) throw error;

      return {
        status: 'success',
        isEligible: orders && orders.length >= 10,
        pointsCount: orders ? orders.length : 0
      };
    } catch (error) {
      console.error('Error checking points eligibility:', error);
      return {
        status: 'error',
        message: error.message || 'حدث خطأ أثناء التحقق من النقاط',
        isEligible: false,
        pointsCount: 0
      };
    }
  },
  // تحديث حالة النقاط للطلبات العشرة الأقدم
  updatePointsStatus: async (userPhone, orderLimit = 10) => {
    try {
      let { data: unusedOrders, error: fetchError } = await supabase
        .from('orders')
        .select('id, created_at')
        .eq('customer_phone', userPhone)
        .eq('status', 'تم التوصيل')
        .eq('points_status', 'unused')
        .order('created_at', { ascending: true });

      if (fetchError) throw fetchError;

      if (!unusedOrders || unusedOrders.length < orderLimit) {
        throw new Error(`عدد النقاط غير كافي لإتمام الطلب المجاني (${unusedOrders?.length || 0}/${orderLimit})`);
      }

      // أخذ أقدم 10 طلبات فقط
      const ordersToUpdate = unusedOrders.slice(0, orderLimit);

      // تحديث حالة النقاط للطلبات المحددة
      const { error: updateError } = await supabase
        .from('orders')
        .update({ points_status: 'used' })
        .in('id', ordersToUpdate.map(order => order.id));

      if (updateError) throw updateError;

      return { 
        status: 'success', 
        message: 'تم تحديث حالة النقاط بنجاح',
        updatedOrders: ordersToUpdate.length
      };

    } catch (error) {
      console.error('Error updating points status:', error);
      return {
        status: 'error',
        message: error.message || 'حدث خطأ أثناء تحديث حالة النقاط'
      };
    }
  },

  // إنشاء طلب مجاني جديد
  createFreeOrder: async (orderData) => {
    try {
      // تحويل أسماء الحقول لتتطابق مع أسماء الأعمدة في قاعدة البيانات
      const formattedOrder = {
        customer_name: orderData.customerName,
        customer_phone: orderData.customerPhone,
        pickup_address: orderData.pickupLocation,
        delivery_address: orderData.deliveryLocation,
        notes: orderData.notes,
        status: 'قيد الانتظار',
        is_free_order: true,
        points_status: 'used',
        created_at: new Date().toISOString()
      };

      const { data, error } = await supabase
        .from('orders')
        .insert([formattedOrder])
        .select()
        .single();

      if (error) throw error;

      return {
        status: 'success',
        message: 'تم إنشاء الطلب المجاني بنجاح',
        data
      };
    } catch (error) {
      console.error('Error creating free order:', error);
      return {
        status: 'error',
        message: error.message || 'حدث خطأ أثناء إنشاء الطلب المجاني'
      };
    }
  }
};